import { ErrorPopupConfig } from '../models';
import { GameErrorCodes } from '../enums';
import { T } from './translation-keys';

export const ErrorPopupConfigs: Record<GameErrorCodes, ErrorPopupConfig | null> = {
  [GameErrorCodes.Reconnect]: null, // handled by game
  [GameErrorCodes.ConnectionError]: {
    hasExit: false,
    hasClose: false,
    hasReload: true,
    title: T.CONNECTION_LOST_TITLE,
    message: T.CONNECTION_LOST_TEXT,
    errorCode: GameErrorCodes.ConnectionError
  },
  [GameErrorCodes.GameIsOpen]: {
    hasExit: false,
    hasClose: false,
    hasReload: true,
    title: T.GAME_IS_OPEN_TITLE,
    message: T.GAME_IS_OPEN_TEXT,
    errorCode: GameErrorCodes.GameIsOpen
  },
  [GameErrorCodes.NotEnoughMoney]: {
    hasExit: false,
    hasClose: true,
    hasReload: false,
    title: T.NOT_ENOUGH_MONEY_TITLE,
    message: T.NOT_ENOUGH_MONEY_TEXT,
    errorCode: GameErrorCodes.NotEnoughMoney
  },
  [GameErrorCodes.PlayerLimitExceeded]: {
    hasExit: true,
    hasClose: true,
    hasReload: false,
    title: T.PLAYER_LIMIT_EXCEEDED_TITLE,
    message: T.PLAYER_LIMIT_EXCEEDED_TEXT,
    errorCode: GameErrorCodes.PlayerLimitExceeded
  },
  [GameErrorCodes.GeneralError]: {
    hasExit: false,
    hasClose: true,
    hasReload: false,
    title: T.GENERAL_ERROR_TITLE,
    message: T.GENERAL_ERROR_TEXT,
    errorCode: GameErrorCodes.GeneralError
  },
  [GameErrorCodes.SessionExpired]: {
    hasExit: true,
    hasClose: false,
    hasReload: true,
    title: T.SESSION_TERMINATED_TITLE,
    message: T.SESSION_TERMINATED_TEXT,
    errorCode: GameErrorCodes.SessionExpired
  },
  [GameErrorCodes.OperatorError]: {
    hasExit: false,
    hasClose: true,
    hasReload: false,
    title: null, // operator error has no title
    message: T.SESSION_TERMINATED_TEXT, // operator error message
    errorCode: GameErrorCodes.OperatorError
  }
};
